module.exports = "<div> <iframe-template path-url={{url}} css=100% key=creatDeclarationDetail></iframe-template> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/declaration/addValTaxDeclaration/creatDeclaration/view/creatDeclarationDetail.html
// module id = Kual
// module chunks = 0